'use client';

import { memo } from 'react';

import Image from 'next/image';
import { useRouter } from 'next/navigation';

import { Link } from '@heroui/react';
import { HiArrowRight } from 'react-icons/hi';
import { v4 as uuidv4 } from 'uuid';

import core from '@/features/v2/home/components/localization/core';

import { cn } from '@/lib/utils';

import { Carousel, CarouselContent, CarouselItem } from '@/components/ui/carousel';

const SportSection = () => {
  const router = useRouter();

  return (
    <section className="flex flex-col px-4 mt-7 md:mt-10 font-text justify-center items-center md:my-6 md:mx-auto md:max-w-8xl">
      <div className="flex justify-between mb-3 items-center w-full max-w-8xl">
        <div className="flex items-center gap-2">
          <Image
            src="/img/v2/icons/ball.svg"
            alt="ball"
            width={34}
            height={34}
            className="h-[34px] w-[34px] object-contain"
            loading="lazy"
            quality={70}
          />
          <p className="text-base font-text font-bold text-white">{core.public.sport.title}</p>
        </div>
        <Link href={core.public.sport.link} className="flex items-center gap-1 border-b-2 border-primary-400 leading-none">
          <p className="text-sm font-bold font-text bg-gradient-to-t from-primary-800 to-primary-600 text-transparent bg-clip-text">{core.public.sport.textLink}</p>
          <HiArrowRight className="text-sm font-bold text-primary-600" />
        </Link>
      </div>

      <div className="w-full max-w-8xl">
        <Carousel
          className="w-full mt-3 z-10 pl-4"
          opts={{
            align: 'start',
            loop: false,
            dragFree: true,
            containScroll: 'trimSnaps',
            startIndex: 0,
            duration: 500,
            active: true,
            slidesToScroll: 1,
            breakpoints: {
              '(min-width: 768px)': {
                slidesToScroll: 2,
                align: 'center',
              },
              '(min-width: 1024px)': {
                slidesToScroll: 1,
                align: 'center',
              },
            },
          }}
        >
          <CarouselContent>
            {core.public.sport.games.map((game) => {
              return (
                <CarouselItem
                  key={uuidv4()}
                  className="basis-auto !w-[165px] !h-48 rounded-xl"
                >
                  <button
                    type="button"
                    onClick={() => { return router.push(game.url); }}
                    className="flex justify-center items-center rounded-lg w-full h-full relative overflow-hidden"
                    style={{
                      width: '100%',
                      height: '100%',
                      backgroundImage: `url(${game.img})`,
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                    }}
                  >
                    <p className="text-lg sm:text-xl font-bold text-white absolute top-3  text-center">
                      {game.imgText}
                    </p>
                    <Image
                      src={game.icon || ''}
                      alt={game.imgText || ''}
                      width={60}
                      height={60}
                      className={cn('w-16 h-16 absolute bottom-14 right-1/2 translate-x-1/2', {
                        'scale-110': game.imgText === 'Fútbol',
                        'scale-125': ['Tenis', 'Boxeo', 'Ciclismo', 'Hockey'].includes(game.imgText),
                      })}
                    />
                  </button>
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  );
};

export default memo(SportSection);
